export default __webpack_public_path__ + "static/media/FDI_ICON.b9f286ba.png";